import {SxType} from "@baseTypes/sx/sxTypes";
import {HEADER_HEIGHT_DESKTOP} from "@view/constants/size";


export const WIDTH_SIDEBAR_PANEL_DESKTOP = 305
export const GAP_FLOATING_SIDEBAR_PANEL = 8
export const SIZE_FLOATING_SIDEBAR_TOGGLE = 42
export const FLOATING_SIDEBAR_PANEL_CLASS = 'floatingSidebarPanel'
export const FLOATING_SIDEBAR_TOGGLE_CLASS = 'floatingSidebarToggle'
export const sx: SxType = {
    floating: {
        position: 'absolute',
        top: `${GAP_FLOATING_SIDEBAR_PANEL}px`,
        left: `${GAP_FLOATING_SIDEBAR_PANEL}px`,
        zIndex: 1001,
        height: 'auto',
        maxHeight: `calc(100% - ${GAP_FLOATING_SIDEBAR_PANEL * 2}px)`,
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.18)',
        paddingBottom: '4px',
    },
    root: {
        flexShrink: 0,
        width: {
            xs: '100vw',
            lg: `${WIDTH_SIDEBAR_PANEL_DESKTOP}px`,
        },

        '.lightTheme &': {
            backgroundColor: '#fff',
        },
        padding: '3px 11px 20px',
        height: '100%',
        overflowY: 'auto',
        boxShadow: '10px 0 20px 0 rgba(0, 0, 0, 0.1)',
        position: {
            xs: 'absolute',
            lg: 'relative'
        },
        left: {
            xs: '50%',
            lg: 'auto'
        },
        top: {
            xs: '50%',
            lg: '0'
        },
        transform: {
            xs: 'translate(-50%,-50%)',
            lg: 'none'
        },
        zIndex: {

        },
        maxHeight:{
            xs:'100vh',
            lg:`calc(100vh - ${HEADER_HEIGHT_DESKTOP})`
        }
    },

    drawerPaper: {
        width: 'min(86vw, 340px)',
        maxWidth: '100%',
        boxSizing: 'border-box',
        padding: '3px 11px 20px',
        overflowY: 'auto',
    },
}